import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Button } from "@covertree/ui";

interface NotesErrorProps {
  disabled: boolean;
  refetch: () => void;
}

export function NotesError({ disabled, refetch }: NotesErrorProps) {
  return (
    <Grid
      item
      xs={12}
      p={3}
      borderRadius={2}
      mb={2}
      bgcolor="secondary.contrastText"
      container>
      <Grid item xs={12}>
        <Typography align="center" gutterBottom>
          Oops! There was an error while fetching notes for this policy.
        </Typography>
      </Grid>

      <Grid item xs={12} justifyContent="center" container>
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          onClick={refetch}
          disabled={disabled}>
          Try again
        </Button>
      </Grid>
    </Grid>
  );
}
